import { fabric } from 'fabric'
import { v4 as guid } from 'uuid'
import { whiteboardConstants } from '@/models/constants'

interface IWbGroupOptions extends fabric.IGroupOptions {
  id?: string
  lock?: boolean
  templateObject?: boolean
  preventUnlock?: boolean
  preventDelete?: boolean
}
const editableProps: Record<string, IWbObjectProp> = {
  lock: { name: 'lock', type: 'lock', editable: true, editableWhenLocked: true },
}
export default class WbGroup extends fabric.Group implements IWbObject {
  public id: string
  public type = whiteboardConstants.objectTypes.group
  public lock: boolean
  public preventUnlock: boolean
  public connectable: boolean
  public templateObject: boolean
  public editableProps: Record<string, IWbObjectProp> = editableProps
  public preventDelete?: boolean
  public canBeLinkedTo = false
  public canLink = false
  public link = undefined
  public actions: Record<string, IWObjectActions> = {
    selectSimilar: { action: 'selectSimilar', label: 'Select Similar', faicon: 'fa-light fa-check-double', showInSubMenu: true },
    unGroup: { action: 'unGroup', label: 'Ungroup', faicon: 'fa-light fa-object-ungroup', showInSubMenu: true },
    bringFront: { action: 'bringFront', label: 'Bring to Front', faicon: 'fa-light fa-bring-front', showInSubMenu: true },
    sendBack: { action: 'sendBack', label: 'Send to Back', faicon: 'fa-light fa-send-back', showInSubMenu: true },
    // group: { action: 'group', label: 'Group', faicon: 'fa-light fa-object-group', showInSubMenu: true, multiple: true },
    cloneAsImage: { action: 'cloneAsImage', label: 'Clone As Image', faicon: 'fa-light fa-clone', showInSubMenu: true },
    delete: { action: 'delete', label: 'Remove', faicon: 'fa-light fa-trash-can', showInSubMenu: true },
  }

  constructor(objects, opt?: IWbGroupOptions) {
    super(objects, opt)
    this.id = opt?.id || guid()
    this.lock = opt?.lock || false
    this.preventUnlock = opt?.preventUnlock || false
    this.connectable = false
    this.originX = 'center'
    this.objectCaching = false
    this.originY = 'center'
    this.templateObject = opt?.templateObject || false
    this.setLock(this.lock)
    this.stateProperties = this.stateProperties?.concat(['lock'])
    this.preventDelete = opt?.preventDelete || false
  }

  setProp(prop: string, value: any) {
    switch (prop) {
      case 'lock':
        this.set('lock', value.lock)
        this.setLock(value.lock)
        break
      default:
        console.warn('Attempting to set unsupported WbObjectProp', prop, value)
        return
    }
    this.dirty = true
    this.canvas?.requestRenderAll()
    this.canvas?.fire('object:modified', { target: this })
  }

  getProp(prop: string) {
    const result: any = {}
    switch (prop) {
      case 'lock':
        result.lock = this.lock
        break
      default:
        console.warn('Attempting to get unsupported WbObjectProp', prop)
    }
    return result
  }

  setLock(lock: boolean) {
    this.set('lockMovementX', lock)
    this.set('lockMovementY', lock)
    this.set('lockRotation', lock)
    this.set('lockScalingFlip', lock)
    this.set('lockScalingX', lock)
    this.set('lockScalingY', lock)
    this.set('hasControls', !lock)
  }

  override toObject() {
    return super.toObject(['id'])
  }

  static fromObject(object: fabric.Object, callback?: Function) {
    return fabric.Object._fromObject(whiteboardConstants.objectTypes.group, object, callback) as WbGroup
  }

  static getEditableProps() {
    return editableProps
  }
}

const f = fabric as any
f.WbGroup = WbGroup
